import { Col } from "antd";

export const Col_doble = ({ style, children }) => {
  return (
    <Col style={{ ...style }} xs={24} sm={16} md={12} lg={8}>
      {children}
    </Col>
  );
};
